"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initCore = initCore;
exports.getConfig = getConfig;
exports.setConfig = setConfig;
exports.loadUserSettings = loadUserSettings;
exports.saveUserSettings = saveUserSettings;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _config = _interopRequireDefault(require("./config"));

var _ContentDelivery = _interopRequireDefault(require("./services/ContentDelivery"));

var _storage = _interopRequireDefault(require("./services/storage"));

var _Logger = _interopRequireDefault(require("./services/Logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var config = _objectSpread({}, _config["default"]);
/**
 * Basic core init with default config, project overrides and runtime overrides
 * @param {Object} customConfig Project overrides for configurable values
 * @returns {Promise}
 */


function initCore(_x) {
  return _initCore.apply(this, arguments);
}
/**
 * Return current config state
 * @returns {{}}
 */


function _initCore() {
  _initCore = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(customConfig) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = _objectSpread(_objectSpread({}, _config["default"]), customConfig);

            if (!config.RUNTIME_CONFIG_URI) {
              _context.next = 7;
              break;
            }

            _context.t0 = setConfig;
            _context.next = 5;
            return _ContentDelivery["default"].loadRuntimeConfig(config.RUNTIME_CONFIG_URI);

          case 5:
            _context.t1 = _context.sent;
            (0, _context.t0)(_context.t1);

          case 7:
            if (!config.LOAD_USER_SETTINGS) {
              _context.next = 13;
              break;
            }

            _context.t2 = setConfig;
            _context.next = 11;
            return loadUserSettings();

          case 11:
            _context.t3 = _context.sent;
            (0, _context.t2)(_context.t3);

          case 13:
            if (config.ERROR_LOG_ENDPOINT) {
              (0, _Logger["default"])(config.ERROR_LOG_ENDPOINT);
            }

            _ContentDelivery["default"].setGlobalBaseUrl(config.BASE_URL);

            return _context.abrupt("return", config);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _initCore.apply(this, arguments);
}

function getConfig() {
  return config;
}
/**
 * Updates run-time config with new values
 * Provided object is merged into original config
 *
 * @param {Object} values
 */


function setConfig(values) {
  config = _objectSpread(_objectSpread({}, config), values);
}
/**
 * Loads user's settings from local storage
 *
 * @param {Boolean} forceLoadCredentials
 * @return {Promise<Object>}
 */


function loadUserSettings() {
  return _loadUserSettings.apply(this, arguments);
}
/**
 * Stores user's settings to local storage
 *
 * @param {Object} config
 * @return {Promise<void>}
 */


function _loadUserSettings() {
  _loadUserSettings = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var forceLoadCredentials,
        result,
        CLIENT_ID,
        CLIENT_SECRET,
        _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            forceLoadCredentials = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
            _context2.t0 = JSON;
            _context2.next = 4;
            return _storage["default"].getItem('FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW');

          case 4:
            _context2.t1 = _context2.sent;
            _context2.t2 = _context2.t0.parse.call(_context2.t0, _context2.t1);
            result = {
              FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW: _context2.t2
            };

            if (!(forceLoadCredentials || result.FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW)) {
              _context2.next = 16;
              break;
            }

            _context2.next = 10;
            return _storage["default"].getItem('CLIENT_ID');

          case 10:
            CLIENT_ID = _context2.sent;
            _context2.next = 13;
            return _storage["default"].getItem('CLIENT_SECRET');

          case 13:
            CLIENT_SECRET = _context2.sent;

            if (CLIENT_ID) {
              result.CLIENT_ID = CLIENT_ID;
            }

            if (CLIENT_SECRET) {
              result.CLIENT_SECRET = CLIENT_SECRET;
            } // TODO: probably these two ifs could be replaced with Object.assign() (as it ignores nulls)


          case 16:
            return _context2.abrupt("return", result);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadUserSettings.apply(this, arguments);
}

function saveUserSettings(_x2) {
  return _saveUserSettings.apply(this, arguments);
}

function _saveUserSettings() {
  _saveUserSettings = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(config) {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = 'FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW' in config;

            if (!_context3.t0) {
              _context3.next = 4;
              break;
            }

            _context3.next = 4;
            return _storage["default"].setItem('FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW', JSON.stringify(config.FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW));

          case 4:
            _context3.t1 = 'CLIENT_ID' in config;

            if (!_context3.t1) {
              _context3.next = 8;
              break;
            }

            _context3.next = 8;
            return _storage["default"].setItem('CLIENT_ID', config.CLIENT_ID);

          case 8:
            _context3.t2 = 'CLIENT_SECRET' in config;

            if (!_context3.t2) {
              _context3.next = 12;
              break;
            }

            _context3.next = 12;
            return _storage["default"].setItem('CLIENT_SECRET', config.CLIENT_SECRET);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _saveUserSettings.apply(this, arguments);
}